import { ViewModel, View } from "binder";
import { getAsNumber } from "../utilities";
import  { PaginatorView } from "./paginator-view"

export class PaginatorViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.paginationInfoUpdater = new EmptyInformer();
        this._isUpdating = true;
        this.currentPage = 1;
        this.pageSize = 15;
        this.pageSize = 0;
        this._isUpdating = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new PaginatorView();
    }
    public getTypeId(): string {
        return "VM-86207139-15D7-434D-8387-047D531EBFD4"
    }
    public set paginationInfoUpdater(v: IPaginationInfoUpdater) { this._paginationInfoUpdater = v; } public get paginationInfoUpdater(): IPaginationInfoUpdater { return this._paginationInfoUpdater;} private _paginationInfoUpdater: IPaginationInfoUpdater;
    public set pageCount(v: number) { this._pageCount = getAsNumber(v,true); } public get pageCount(): number { return this._pageCount;} private _pageCount: number;
    public set currentPage(v: number) { 
        this._currentPage = getAsNumber(v,true); 
        this.loadPageData();
    } public get currentPage(): number { return this._currentPage;} private _currentPage: number;
    public set pageSize(v: number) { this._pageSize = getAsNumber(v,true); } public get pageSize(): number { return this._pageSize;} private _pageSize: number;
    
    gotoFirst(){
        this.goto(1);
    }
    gotoLast(){
        this.goto(this.pageCount);
    }
    gotoPrev(){
        this.goto(this.currentPage-1);
    }
    gotoNext(){
        this.goto(this.currentPage+1);
    }
    goto(page:number){
        this.changePageTo(page);
    }
    private async changePageTo(pageNo:number){
        if(pageNo<1){
            this.currentPage = 1;
        }else if(pageNo>this.pageCount){
            this.currentPage = this.pageCount;
        }else{
            this.currentPage = pageNo;
        }
    }

    private _isUpdating:boolean;

    public updatePaginationInfo(pageNo:number,pageCount:number){
        this.pageCount = pageCount;
        this._isUpdating = true;
        this.currentPage = pageNo;
        this._isUpdating = false;
    }
    private async loadPageData(){
        if(this._isUpdating)
            return;
        this._isUpdating = true;
        let newinfo = await this.paginationInfoUpdater.informPageChange(this.currentPage,this.pageSize);
        if(newinfo==null){
            this._isUpdating = false;
            return;
        }
        if(newinfo.currentPage<=newinfo.pageCount){
            this.pageCount = newinfo.pageCount;
            this.currentPage = newinfo.currentPage;
            this._isUpdating = false;
        }else{
            this.pageCount = newinfo.pageCount;
            this._isUpdating = false;
            this.goto(newinfo.currentPage);
        }
    }
}


export class PaginationInfo{
    public pageCount : number;
    public currentPage : number;
    public omit:boolean;
    constructor(currentPage?:number,pageCount?:number) {
        if(currentPage==null){
            this.omit = true;
        }else{
            this.pageCount = pageCount;
            this.currentPage = currentPage;
            this.omit = false;
        }
    }
}
export interface IPaginationInfoUpdater{
    informPageChange(pageNo:number,pageSize : number):Promise<PaginationInfo>;
}

class EmptyInformer implements IPaginationInfoUpdater{
    async informPageChange(pageNo: number, pageSize: number): Promise<PaginationInfo> {
        return new PaginationInfo(pageNo,pageNo);
    }

}
